// extracted by mini-css-extract-plugin
module.exports = {"main-component":"blockerResolved_main-component__1U1QD"};